import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import {VulnerabilityFragment} from '../../schema-types/VulnerabilityFragment';

type Props = {
  rows: VulnerabilityFragment[];
  /** Row id to whether the vulnerability continues; missing means "Yes". */
  continuing: Record<string, boolean>;
  onContinuingChange: (rowId: string, value: boolean) => void;
  readOnly?: boolean;
};

/**
 * SFP tube stop: the contact's active, un-ended vulnerabilities from Curo. Only
 * "Continuing?" is editable; "No" ends the row in Curo on review submission.
 */
export const ExistingVulnerabilitiesTable: React.FC<Props> = ({
  rows,
  continuing,
  onContinuingChange,
  readOnly = false,
}) => {
  if (rows.length === 0) {
    return <Typography color="text.secondary">No existing vulnerabilities</Typography>;
  }
  return (
    <Table size="small" aria-label="Existing vulnerabilities">
      <TableHead>
        <TableRow>
          <TableCell>Vulnerability</TableCell>
          <TableCell>Service Level</TableCell>
          <TableCell>Continuing?</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row) => {
          const isContinuing = continuing[row.id] ?? true;
          return (
            <TableRow key={row.id}>
              <TableCell>{row.vulnerabilityType}</TableCell>
              <TableCell>{row.serviceLevel}</TableCell>
              <TableCell>
                <ToggleButtonGroup
                  size="small"
                  exclusive
                  color="primary"
                  disabled={readOnly}
                  value={isContinuing ? 'yes' : 'no'}
                  onChange={(_event, value: 'yes' | 'no' | null) => {
                    if (value !== null) {
                      onContinuingChange(row.id, value === 'yes');
                    }
                  }}
                  aria-label={`${row.vulnerabilityType} continuing`}
                >
                  <ToggleButton value="yes">Yes</ToggleButton>
                  <ToggleButton value="no">No</ToggleButton>
                </ToggleButtonGroup>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
